module.exports = __webpack_public_path__ + "media/images/spinner-0d11f65142981e319bf19e21bdb19090.gif";